/* global angular, $ */
angular.module('ua5App')
    .controller('SearchCtrl', ['close', '$scope', '$timeout', '$state', '$rootScope', 'SearchFactory', function(close, $scope, $timeout, $state, $rootScope, SearchFactory) {

        var curState = $state.current.name;
        var curTerm = '',
            resultTerm = '';

        $scope.loadingText = '';

        $timeout(function() {
            var closeBtn = $('.search__close').eq(0);
            switch (curState) {
                case 'single':
                    closeBtn.attr('data-state', 'single');
                    break;
                case 'home.resources':
                    closeBtn.attr('data-state', 'resources');
                    break;
                case 'calendar':
                    closeBtn.attr('data-state', 'calendar');
                    break;
                case 'home.community':
                    closeBtn.attr('data-state', 'community');
                    break;
                default:
                    // defaults to home
                    closeBtn.attr('data-state', '');
            }
        });

        $scope.currentState = $state.current.name.substring($state.current.name.lastIndexOf('.') + 1);

        this.close = close;
        $scope.searchModel = '';
        $scope.focused = false;
        $scope.results = [];

        function changeLoadingText(numCur) {
            // this is for when there are multiple search apis firing
            // number of differnet types of searches being done, right now it's resources + posts
            var numTotalSearches = 1;
            if (numCur === numTotalSearches) {
                $scope.loadingText = '';
            } else {
                $scope.loadingText = 'SO FAR';
            }
        }

        function searchFor(term) {
            var numSearches = 0;

            if (term.length < 2) {
                // don't perform search until 2 characters are entered
                return false;
            }

            changeLoadingText(numSearches);

            term = term.toLowerCase();
            curTerm = term;

            $scope.results = [];

            SearchFactory.search().query({query:term}).$promise.then(function(results) {
                if (curTerm === term) {
                    // make sure to only show the latest search query
                    resultTerm = term;
                    $scope.results = $scope.results.concat(results);
                }
                numSearches++;
                changeLoadingText(numSearches);
            });
        }

        $scope.$watch('searchModel', function(newSearchModel, oldSearchModel) {
            if (newSearchModel !== oldSearchModel) {
                if (newSearchModel === '') {
                    $scope.results = [];
                } else {
                    searchFor($scope.searchModel);
                }
            }
        });

        $scope.onCloseClick = function() {
            $scope.$broadcast('modal:closed');
        };

        $scope.$on('globalHeader:search:closed', function(e) {
            $scope.onCloseClick();
        });

        $scope.$on('globalHeader:logo:clicked', function() {
            $scope.onCloseClick();
        });

        $rootScope.$broadcast('globalHeader:search:create');
        $scope.$on('$destroy', function() {
            $rootScope.$broadcast('globalHeader:search:destroy');
        });

        $scope.$on('app:enterPressed', function() {
            // When enter is clicked, navigate to the first result's state.
            var firstResult;
            if ($scope.results.length > 0) {
                // Make sure there are results
                firstResult = $scope.results[0];
                // Update value of input to reflect selected item.
                $scope.searchModel = firstResult.title;
                $timeout(function() {
                    if (firstResult.type === 'resource') {
                        // If a resource, go to a resource state.
                        $state.go('home.resources', {
                            slug: firstResult.slug,
                            section: firstResult.section
                        });
                    } else {
                        // Otherwise we must be going to a single state.
                        $state.go('single', {
                            slug: firstResult.slug
                        });
                    }
                }, 500);
            }
        });

        $timeout(function() {
            $('.search__form__field').focus();
        });

        // Close search when state changes
        $scope.$on('$stateChangeStart', function(e, toState) {
            $scope.onCloseClick();
        });

    }])
;
